module.exports = __webpack_public_path__ + "img/dentist-men.21634ae6.png";